import { createMuiTheme } from '@material-ui/core/styles';

let theme = createMuiTheme({
	typography: { fontFamily: 'DM Sans', fontSize: 14 },
});

theme = createMuiTheme({
	typography: {
		fontFamily: 'DM Sans',
	},
	palette: {
		primary: {
			light: '#2D6ED4',
			main: '#0033FF',
			dark: '#0028C8',
		},
		secondary: {
			main: '#32ff34',
		},
		success: {
			light: '#52C229',
			main: '#34A10D',
			dark: '#288C03',
		},
		error: {
			light: '#D42C40',
			main: '#A60D1F',
			dark: '#870312',
		},
		warning: {
			light: '#F1A540',
			main: '#E88F1A',
			dark: '#CA7302',
		},
		grey: {
			50: '#FAFAFA',
			100: '#F5F5F5',
			200: '#EEEEEE',
			300: '#E0E0E0',
			400: '#BDBDBD',
			500: '#9E9E9E',
			600: '#757575',
			700: '#616161',
			800: '#424242',
			900: '#212121',
		},
	},
});

export default theme;
